export const CANCEL_FETCH_MESSAGE =
  'Cancel current fetch, another one is starting';
